import React from 'react';
import { FaCheck } from 'react-icons/fa';

/**
 * Shared user photo treatment: circular frame + optional role badge
 * (top-left) + optional verified dot (bottom-right). Matches the existing
 * Dashboard hero avatar so Sidebar/Topbar/tables read as one system instead
 * of each page inventing its own avatar style.
 */
export default function UserAvatar({
  src,
  alt = 'User',
  size = 32,
  badgeIcon = null,
  verified = false,
  ring = '#0b1226',
  fallback = '/user.png',
}) {
  const badgeSize = Math.max(14, Math.round(size * 0.42));
  const checkSize = Math.max(13, Math.round(size * 0.38));

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <img
        src={src || fallback}
        alt={alt}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2px solid var(--border-strong, rgba(150,175,220,0.18))',
          display: 'block',
        }}
        onError={(e) => {
          if (!e.currentTarget.dataset.fallback) {
            e.currentTarget.dataset.fallback = '1';
            e.currentTarget.src = fallback;
          }
        }}
      />
      {badgeIcon && (
        <span
          style={{
            position: 'absolute',
            top: -3,
            left: -3,
            width: badgeSize,
            height: badgeSize,
            borderRadius: '50%',
            background: '#7c3aed',
            border: `2px solid ${ring}`,
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            fontSize: badgeSize * 0.55,
          }}
        >
          {badgeIcon}
        </span>
      )}
      {verified && (
        <span
          style={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: checkSize,
            height: checkSize,
            borderRadius: '50%',
            background: '#22c55e',
            border: `2px solid ${ring}`,
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
          }}
        >
          <FaCheck style={{ fontSize: checkSize * 0.5 }} />
        </span>
      )}
    </div>
  );
}
